<template>
  <div class="item-master-history  fw">
        <div v-if="historyLoader" class="fh fw center loader-conatainer">
          <loading-circle />
        </div>
        <!-- history start  -->
        <i
          v-else-if="!Object.keys(materialHistory).length"
          class="material-history-box p-3 center"
        >
          History is not available
        </i>
        <div v-else  class="material-history-box item-master-history__card ">
           <div  class="material-header">
      <div class="material-header-toggle">
        <div class="material-header-toggle-box">
          <button class="material-header-toggle-btn" @click="openTab('history')">
            Material
          </button>
          <button class="material-header-toggle-btn" @click="openTab('wf')">
            Workflow
          </button>
        </div>
        <div
          class="material-header-toggle-selection"
          ref="backgroundShade"
        ></div>
      </div>
    </div>
    <div v-if="tab === 'history'">
          <div
            v-for="(dateArray, index) in materialHistory"
            class="material-history-body"
            :key="index"
          >
            <div class="material-history-body-dateBox">
              <div class="material-history-body-date">
                <img src="~@/assets/images/icons/calenderGrey.svg" width="12px" alt="" />
                {{ dateArray[0].timestamp | timeStampToDate }}
              </div>
              <hr class="material-history-body-date-line" />
            </div>
            <div class="material-history-body-elementsBox">
              <history-element
                v-for="(item, index) in dateArray"
                :key="index"
                :data="item"
                :elementColor="'238, 159, 214'"
              />
            </div>
          </div>
          </div>
           <div v-if="tab === 'wf'" class="item-master-workflows__card">
      <div class="item-master-workflows__title">
        <img class="item-master-workflows__icon" :src="workflowIcon" alt="Workflows" />
        <span>Workflow History</span>
      </div>
       <div v-for="(dateArray, index) in wfHistory" class="history-body" :key="index">
        <div class="history-body-dateBox">
          </div>
          <div class="history-body-elementsBox">
            <workflow-history  v-for="(item, index) in dateArray" :key="index" :data="item"/>
          </div>
        </div>
        <div v-if="Object.keys(wfHistory).length === 0" class="item-master-history__empty">
          No  Workflows Linked.
        </div>
    </div>
        </div>
        </div>
</template>

<script>
import { getAllWFLifeCycle, getMaterialHistory } from '@/api'
import LoadingCircle from '@/components/common/loadingCircle.vue'
import Config from '@/config'
import { timeStampToDateTime } from '@/filters/dateFilter'
import HistoryElement from '@/views/FORM/historyElement.vue'
import WorkflowHistory from '@/views/MATERIAL-MASTER/WfHistory.vue'

export default {
  name: 'ItemMasterHistorySection',
  props: {
    materialMaster: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    HistoryElement,
    LoadingCircle,
    WorkflowHistory
  },
  filters: {
    timeStampToDateTime,
    timeStampToDate (timestamp) {
      return new Date(timestamp).toLocaleDateString('en-US', {
        weekday: 'long', // Sunday
        month: 'short', // Jul
        day: 'numeric' // 20
      })
    }
  },
  data () {
    return {
      materialHistory: [],
      historyLoader: false,
      wfHistory: {},
      tab: 'history'
    }
  },
  computed: {
    workflowIcon () {
      return require('@/assets/images/icons/workflow-icon.svg')
    },
    historyItems () {
      if (Array.isArray(this.materialMaster.history) && this.materialMaster.history.length) {
        return this.materialMaster.history.map((item, index) => ({
          id: item.id || index,
          typeLabel: item.type || 'UPDATED',
          typeClass: item.typeClass || 'badge-updated',
          field: item.field || 'Field',
          from: item.from || '--',
          to: item.to || '--',
          user: item.user || 'Unknown',
          date: item.date || '--'
        }))
      }
      return [
        {
          id: 1,
          typeLabel: 'UPDATED',
          typeClass: 'badge-updated',
          field: 'Supplier',
          from: 'Old Supplier Inc.',
          to: 'Valve-Tech Industries',
          user: 'Vishakha Gupta',
          date: '10 Mar 2026'
        },
        {
          id: 2,
          typeLabel: 'UPDATED',
          typeClass: 'badge-updated',
          field: 'Lead Time',
          from: '10 days',
          to: '7 days',
          user: 'Vishakha Gupta',
          date: '10 Mar 2026'
        },
        {
          id: 3,
          typeLabel: 'CREATED',
          typeClass: 'badge-created',
          field: 'Material Created',
          from: '--',
          to: '--',
          user: 'Vishakha Gupta',
          date: '1 Jan 2026'
        }
      ]
    },
    historyIcon () {
      return require('@/assets/images/icons/history-icon.svg')
    }
  },
  methods: {
    loadHistory () {
      this.historyLoader = true
      getMaterialHistory(this.materialMaster.id).then((res) => {
        this.materialHistory = {}
        const history = res
        for (const item of history ?? []) {
          const date = new Date(item.timestamp)
          const dateStr = date.toISOString().split('T')[0]
          switch (item.state) {
          case 'STARTED':
            item.elementColor = Config.elementColor.green
            break
          case 'CLOSED':
            item.elementColor = Config.elementColor.orange
            break
          case 'ASSIGNED':
            item.elementColor = Config.elementColor.blue
            break
          case 'CANCELLED':
            item.elementColor = Config.elementColor.red
            break
          case 'UPDATED':
            item.elementColor = Config.elementColor.purple
            break
          case 'INSERTED':
            item.elementColor = Config.elementColor.green
            break
          case 'DELETED':
            item.elementColor = Config.elementColor.red
            break
          default:
            item.elementColor = Config.elementColor.blue
            break
          }

          if (!this.materialHistory[dateStr]) {
            this.materialHistory[dateStr] = []
          }
          this.materialHistory[dateStr].push(item)
        }
        this.historyLoader = false
      })
        .catch(() => {
          this.historyLoader = false
        })
    },
    getWorkflowHistory () {
      getAllWFLifeCycle(this.materialMaster.id).then((res) => {
        this.loadHistory = false
        this.wfHistory = {}
        for (const item of res.workflow_instances) {
          const date = new Date(item.created_on)
          const dateStr = date.toDateString().split(' ').slice(1).join('-')
          if (!this.wfHistory[dateStr]) {
            this.wfHistory[dateStr] = []
          }
          for (const ele of item.transition_history) {
            item.end_Date = ele?.end_date !== null ? new Date(ele?.end_date).toDateString().split(' ').slice(1).join('-') : null
          }
          item.created_on = dateStr
          this.wfHistory[dateStr].push(item)
        }
      })
    },
    openTab (type) {
      if (type === 'history') {
        this.$refs.backgroundShade.style.transform = 'translateX(0%)'
      } else {
        this.$refs.backgroundShade.style.transform = 'translateX(100%)'
      }
      this.tab = type
    }
  },
  mounted () {
    this.loadHistory()
    this.getWorkflowHistory()
  }
}
</script>

<style lang="scss" scoped>
.item-master-history {
   border-radius: 14px;
  padding: 24px 32px 8px 32px;

  &__card {
    border: 1px solid #e5e7eb;
    border-radius: 14px;
    padding: 20px 22px;
    background: #ffffff;
  }

  &__title {
    display: flex;
    align-items: center;
    gap: 10px;
    font-weight: 600;
    color: #0f172a;
    margin-bottom: 16px;
  }

  &__icon {
    width: 18px;
    height: 18px;
  }

  &__list {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  &__item {
    display: flex;
    gap: 16px;
    padding-bottom: 16px;
    border-bottom: 1px solid #e5e7eb;
  }

  &__item:last-child {
    border-bottom: none;
    padding-bottom: 0;
  }

  &__badge {
    min-width: 86px;
    height: 26px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    font-weight: 700;
  }

  &__content {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  &__field {
    font-weight: 600;
    color: #0f172a;
  }

  &__change {
    font-size: 13px;
    color: #475569;
  }

  &__meta {
    font-size: 12px;
    color: #94a3b8;
  }

  &__empty {
    color: #94a3b8;
    font-size: 13px;
  }
}
$selection-height: 28px;
$greyShade-color: #b8b7b7;
.badge-updated {
  background: #e0ecff;
  color: #1d4ed8;
}

.badge-created {
  background: #dcfce7;
  color: #15803d;
}
.material {

  &-history {
    &-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 300px;
& .loader-conatainer{
      flex-grow: 1;
      min-width: fit-content;
    min-height: fit-content;
}
  }
    &-box {
      // -webkit-animation: slide-left 0.5s ease-in 1 alternate;
      // animation: slide-left 0.5s ease-in 1 alternate;
      width: 100%;
      height: 100%;
    }
    &-body {
      margin-top: 1.5em;
      padding: 5px;
      &-dateBox {
        display: flex;
        gap: 10px;
        align-items: center;
        font-size: 0.8em;
      }
      &-date {
        display: flex;
        align-items: center;
        gap: 5px;
        color: #b5b4b4;
      }
      &-date-line {
        flex-grow: 1;
        border: none;
        height: 0.5px;
        background-color: #cccccc81;
      }
      &-elementsBox {
        padding: 5px;
        overflow: auto;
      }
    }
  }
   &-header {
    padding-inline: 0.5em;
    display: flex;
    width:100%;
    justify-content: center;
    background-color:inherit;
    top: 0;
    z-index: 2;
    &-toggle {
      background-color:rgba($greyShade-color, 0.3);
      position: relative;
      height: calc($selection-height + 2px);
      width: calc(115px*2);
      border-radius: 4px;
      &-box {
        position: absolute;
        z-index: 1;
        border: 0.4px solid rgb(219, 214, 214);
        height: calc($selection-height + 2px);
        width: 100%;
        border-radius: 4px;
        display: flex;
        background: transparent;
        font-size: 0.85em;
      }
      &-btn {
        all: unset;
        flex: 1;
        height: $selection-height;
        text-align: center;
        cursor: pointer;
        background: transparent;
      }
      &-selection {
        position: absolute;
        width: 50%;
        background-color: white;
        left: 0;
        top: 0;
        bottom: 0;
        height: calc($selection-height + 2px);
        z-index: 0;
        border-radius: 4px;
        transition: all 0.3s ease;
      }
    }
  }
}

@media (max-width: 768px) {
  .item-master-history {
    padding: 20px;
  }
}
.item-master-workflows {
  padding: 24px 32px 8px 32px;

  &__card {
    border: 1px solid #e5e7eb;
    border-radius: 14px;
    padding: 20px 22px;
    background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
    box-shadow: 0 8px 20px rgba(15, 23, 42, 0.08);
    margin-top: 20px;
  }

  &__title {
    display: flex;
    align-items: center;
    gap: 10px;
    font-weight: 400;
    font-size: var(--text-s);
    color: #0f172a;
    margin-bottom: 16px;
  }

  &__icon {
    width: 15px;
    height: 15px;
    filter: invert(54%) sepia(48%) saturate(531%) hue-rotate(350deg) brightness(90%) contrast(90%);
  }

  &__status.status-ongoing {
    background-color: rgba(255, 165, 0, 0.1);
    color: orange;
  }

  &__status.status-completed {
    background-color: rgba(0, 128, 0, 0.1);
    color: green;
  }

  &__status.status-cancelled {
    background-color: rgba(198, 39, 52, 0.1);
    color: red;
  }

  &__status.status-neutral {
    background-color: rgba(148, 163, 184, 0.15);
    color: #475569;
  }
}
</style>
